module.exports = __webpack_public_path__ + "img/Girl_010033.8bc88b67.png";